/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=3cf4c858"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3cf4c858&lang=css"

import exportComponent from "D:\\workspace\\vue-ai_evaluation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__